module.exports = __webpack_public_path__ + "static/img/erweima.8e3cf6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erweima.png
// module id = hMRt
// module chunks = 1